<script setup>
    import '~/assets/css/catalog-community.css';
    import '~/assets/css/catalog-choice.css';
    const route=useRoute();
    const props = defineProps(['seeds','discovery']);
    const ids=computed(()=>props.seeds.slice(0,100).map(p=>p.id).join(','));
    const {data:ratings,error:ratingError}=await useFetch('/api/plant-ratings/summaries',{query:{ids},watch:[ids]});
    const choiceIds=computed(()=>props.seeds.slice(0,60).map(p=>p.id).join(','));
    const {data:choice}=await useFetch('/api/catalog/choice-data',{query:computed(()=>({ids:choiceIds.value}))});
    const facts=computed(()=>Object.fromEntries((choice.value?.plants||[]).map(p=>[p.id,p.facts])));
</script>

<template>
    <div class="uo-catalog-seeds-grid uo-community grid gap-3 grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6 items-start mb-4">
        <template v-for="(seed,index) in seeds" :key="seed.id"><article class="grid gap-2"><nuxt-link :to="`/catalog/product-${seed.id}`" class="grid gap-2">
            <CatalogPlantImage
                class="rounded-xl border-[0.5px] object-cover w-full aspect-square text-center text-sm text-slate-400 first-letter:uppercase"
                :uuid="seed?.images[0]?.uuid"
                :alt="seed?.title"
            />
            <span class="m-0 text-l text-center">
                {{ seed.title }}
            </span>
            <small v-if="seed.matched_synonym" class="text-center text-slate-500">Найдено по синониму: {{seed.matched_synonym}}</small>
        </nuxt-link><dl v-if="facts[seed.id]?.length" class="uo-choice-facts"><div v-for="fact in facts[seed.id]" :key="fact.name"><dt>{{fact.label}}</dt><dd>{{fact.value}}</dd></div></dl><RatingPlantSummary compact :plant-id="seed.id" :summary="ratings?.plants?.[seed.id]" :unavailable="!!ratingError" :stale="ratings?.stale" /><CatalogCompareButton :plant="seed" /></article><CatalogDiscovery v-if="discovery && index===Math.min(5,seeds.length-1)" class="uo-catalog-inline-discovery" :category="String(route.params.subcategory || route.params.category || '')" /></template>
    </div>
</template>
